import styles from "./CV.module.scss";
import About from "./components/About";
import Header from "./components/Header";
import Contacts from "./components/Contacts";
import Skills from "./components/Skills";

function CV() {
  return (
    <div className={styles["cv-container"]} data-depth="0.1">
      <Header />
      <main className={styles.main}>
        <About />
        <Contacts />
        <Skills />
      </main>
    </div>
  );
}

export default CV;
